import { useContext, useEffect, useState } from 'react';
import IMedicalCertificate from '../../interfaces/IMedicalCertificate';
import { DetailContainer } from './FollowupList.styled';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { BiAddToQueue } from 'react-icons/bi';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  AlertTitle,
  Avatar,
  Backdrop,
  Button,
  Card,
  Chip,
  CircularProgress,
  Dialog,
  Divider,
  Grid,
  IconButton,
  LinearProgress,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Tooltip,
  Typography
} from '@mui/material';
import useCpfCnpjFormat from '../../hooks/util/useCpfCnpjFormat';
import moment from 'moment';
import { getTimeQuanitity, status, statusColors } from './followupUtil';
import DeleteIcon from '@mui/icons-material/Delete';
import { MdOutlineBadge } from 'react-icons/md';
import IDiseaseClassification from '../../interfaces/IDiseaseClassification';
import { alpha, Box } from '@mui/system';
import { IAttachment } from '../../interfaces/IAttachment';
import FollowupDiseaseClassificationForm from './FollowupDiseaseClassificationForm';
import Transition from './FollowupTransition';
import { useMedicalCertificateService } from '../../hooks/services/useMedicalCertificateService';
import { useToastrVanila } from '../../hooks/util/useToastrVanila';
import FollowupJustification from './FollowupJustification';
import MedicalCertificateForm from '../internal-medical-certificate/medical-certificate-form/MedicalCertificateForm';
import FollowupLastDocuments from './FollowupLastDocuments';
import IEmployee from '../../interfaces/IEmployee';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useEmployeeService } from '../../hooks/services/useEmployeeService';
import UserContext from '../../context/user/UserContext';
import { useCompanyService } from '../../hooks/services/useCompanyService';
import ICompany from '../../interfaces/ICompany';
import FollowupEditDeadline from './FollowupEditDeadline';
import ITenant from '../../interfaces/ITenant';
import { useTenantService } from '../../hooks/services/useTenantService';
import { ChevronLeft, ChevronRight, Person, ViewList } from '@mui/icons-material';
import AnexosGrid from '../../components/image-viewer/AnexoGrid';
import { useNavigate } from 'react-router-dom';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { hasAccessTo, hasAccessToAction } from '../../util/hasAccessTo';
interface IProps {
  medicalCertificateId: string;
  employeeId: number;
  closeDialog: () => void;
  isOpen: boolean;
  documentIds: string[];
  totalRows: number;
  onRequestPage: (direction: 'next' | 'prev') => Promise<boolean>;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

type FieldProps = { label: string; value?: string | null; sub?: string; mono?: boolean };

const FollowupDetail = (props: IProps) => {
  const [openCidForm, setOpenCidForm] = useState(false);
  const [openEditForm, setOpenEditForm] = useState(false);
  const [openEditDeadline, setOpenEditDeadline] = useState(false);
  const [loadingRemoveDisease, setLoadingRemoveDisease] = useState(false);
  const [medicalCertificate, setMedicalCertificate] = useState<IMedicalCertificate | null>(null);
  const [diesases, setDiseaes] = useState<IDiseaseClassification[]>([]);
  const [attachments, setAttachments] = useState<IAttachment[]>([]);
  const [loading, setLoading] = useState(false);
  const [isdialogJustifyOpen, setIsDialogJustifyOpen] = useState(false);
  const [dialogStatus, setDialogStatus] = useState<
    'DISAPPROVED' | 'ARCHIVED' | 'DISAPPROVEDBYMANAGER' | 'ARCHIVEDBYMANAGER' | 'APPROVED'
  >('DISAPPROVED');
  const [employee, setEmployee] = useState<IEmployee>();
  const [company, setCompany] = useState<ICompany>();
  const { formatCpf } = useCpfCnpjFormat();
  const medicalCertificateRequest = useMedicalCertificateService();
  const requestTenant = useTenantService();
  const employeeService = useEmployeeService();
  const companyService = useCompanyService();
  const [tenant, setTenant] = useState<ITenant | null>(null);
  const [seeCID, setSeeCid] = useState<boolean>(false);

  const toastr = useToastrVanila();

  const {
    medicalCertificateId,
    documentIds = [],
    totalRows,
    closeDialog,
    onRequestPage,
    hasNextPage,
    hasPrevPage
  } = props;

  const navigate = useNavigate();
  const [loadingPage, setLoadingPage] = useState(false);
  const [pendingDirection, setPendingDirection] = useState<'next' | 'prev' | null>(null);
  const currentIndex = documentIds.indexOf(medicalCertificateId);
  const canGoPrev = currentIndex > 0 || hasPrevPage;
  const canGoNext = currentIndex < documentIds.length - 1 || hasNextPage;

  const goToNext = async () => {
    if (loadingPage) return;
    // Caso normal: tem próximo ID no array
    if (currentIndex < documentIds.length - 1) {
      navigate(`/followup/editar-atestado/${documentIds[currentIndex + 1]}`, { replace: true });
      return;
    }
    // Chegou no fim: pede próxima página
    if (hasNextPage) {
      setLoadingPage(true);
      setPendingDirection('next');
      await onRequestPage('next');
      setLoadingPage(false);
    }
  };

  const goToPrev = async () => {
    if (loadingPage) return;

    if (currentIndex > 0) {
      navigate(`/followup/editar-atestado/${documentIds[currentIndex - 1]}`, { replace: true });
      return;
    }

    if (hasPrevPage) {
      setLoadingPage(true);
      setPendingDirection('prev');
      await onRequestPage('prev');
      setLoadingPage(false);
    }
  };

  const { state } = useContext(UserContext);

  const canView = hasAccessToAction(
    ["followup-atestado-web"],
    state.resourcesWithActions, 
    "Editar"
  );

  useEffect(() => {
    if (props.isOpen) {
      loadMedicalCertificate();
      listDiseases();
      getTenant();
      userSeeCID();
    }
  }, [props.isOpen, openEditDeadline]);

  const loadMedicalCertificate = async (): Promise<void> => {
    setLoading(true);
    medicalCertificateRequest
      .listById(props.medicalCertificateId)
      .then(result => {
        setLoading(false);
        setMedicalCertificate({ ...result });
        setAttachments(result?.attachments || []);
        if (result.employeeId) {
          loadEmployee(result.employeeId);
          loadCompany(result.employeeId);
        }
      })
      .catch(() => {
        setLoading(false);
        toastr.error('Ocorreu um erro ao carregar documento.');
      });
  };

  const loadEmployee = async (empId: number): Promise<void> => {
    setLoading(true);
    employeeService.listById(empId)
      .then(result => {
        setLoading(false);
        setEmployee({ ...result });
      })
      .catch(() => {
        setLoading(false);
        toastr.error('Ocorreu um erro ao carregar informações do colaborador.');
      });
  };

  const loadCompany = async (empId: number): Promise<void> => {
    setLoading(true);
    companyService.listByEmployeeId(empId)
      .then(result => {
        setLoading(false);
        setCompany({ ...result });
      })
      .catch(() => {
        setLoading(false);
        toastr.error('Ocorreu um erro ao carregar informações da empresa.');
      });
  };

  const updateStatus = async (
    status:
      | 'PENDING'
      | 'APPROVED'
      | 'DISAPPROVED'
      | 'ARCHIVED'
      | 'APPROVEDBYMANAGER'
      | 'DISAPPROVEDBYMANAGER'
      | 'ARCHIVEDBYMANAGER',
    eventDescription?: string,
  ): Promise<void> => {
    setLoading(true);
    if (hasAccessTo(['atestado-digital-rh'], state.resourcesWithActions)) {
      medicalCertificateRequest
        .updateMedicalCertificateStatus(props.medicalCertificateId, status, eventDescription)
        .then(async () => {
          await loadMedicalCertificate();
          toastr.success('Situação do documento atualizada com sucesso!');
          setLoading(false);
        })
        .catch(err => {
          setLoading(false);
          toastr.error(err.message);
        });
    } else {
      medicalCertificateRequest
        .updateMedicalCertificateStatus(props.medicalCertificateId, status, eventDescription)
        .then(async () => {
          await loadMedicalCertificate();

          toastr.success('Situação do documento atualizada com sucesso!');
          setLoading(false);
        })
        .catch(err => {
          setLoading(false);
          toastr.error('Ocorreu um erro atualizar documento.');
          toastr.error(err.message);
        });
    }
  };

  const listDiseases = async (): Promise<void> => {
    setLoading(true);
    medicalCertificateRequest
      .listDiseasesByMedicalCertificateId(props.medicalCertificateId)
      .then(result => {
        setLoading(false);
        setDiseaes(result);
      })
      .catch(() => {
        setLoading(false);
        toastr.error('Ocorreu um erro ao carregar a lista de doenças.');
      });
  };

  const isEditable =
    medicalCertificate?.status !== 'ARCHIVED' ||
    medicalCertificate?.statusIntegration !== 'SUCCESS';

  const renderDeleteAction = (diseaseId: string) =>
    isEditable ? (
      <Tooltip title="Excluir CID" placement="left">
        <IconButton edge="end" aria-label="delete" onClick={() => removeDisease(diseaseId)} disabled={!canView}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    ) : null;

  const removeDisease = async (id: string): Promise<void> => {
    setLoadingRemoveDisease(true);
    medicalCertificateRequest
      .removeDiseasesClassification(id)
      .then(async () => {
        setLoadingRemoveDisease(false);
        await listDiseases();
      })
      .catch(() => {
        setLoadingRemoveDisease(false);
        toastr.error('Ocorreu um erro ao remover cid de doenças.');
      });
  };

  const getTenant = async () => {
    setLoading(true);
    await requestTenant
      .getTenant()
      .then(result => {
        setTenant({ ...result });
        setLoading(false);
      })
      .catch(error => {
        toastr.error(error.message);
        setLoading(false);
      });
  };

  const userSeeCID = async () => {
    const resourceKeys = Object.keys(state.resourcesWithActions || {});
    if (
      !tenant?.showCIDForManager &&
      resourceKeys.some(resource => resource === 'atestado-digital-gestor') &&
      resourceKeys.length === 1
    ) {
      setSeeCid(false);
      return;
    } else {
      setSeeCid(true);
    }
  };

  useEffect(() => {
    if (!pendingDirection) return;

    const idx = documentIds.indexOf(medicalCertificateId);

    if (pendingDirection === 'next' && idx < documentIds.length - 1) {
      navigate(`/followup/editar-atestado/${documentIds[idx + 1]}`, { replace: true });
      setPendingDirection(null);
    }

    if (pendingDirection === 'prev' && idx > 0) {
      navigate(`/followup/editar-atestado/${documentIds[idx - 1]}`, { replace: true });
      setPendingDirection(null);
    }
  }, [documentIds, pendingDirection]);

  // Componente interno - 
  const Field = ({ label, value, sub, mono }: FieldProps) => (
    <Box sx={{ minWidth: 0 }}>
      <Typography sx={{ fontSize: 11, color: 'text.secondary', lineHeight: 1.4 }}>
        {label}
      </Typography>
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 500,
          fontFamily: mono ? 'monospace' : 'inherit',
          fontVariantNumeric: mono ? 'tabular-nums' : 'normal',
          mt: 0.25,
          color: value ? 'text.primary' : 'text.disabled',
          wordBreak: 'break-word',
        }}
      >
        {value || '—'}
      </Typography>
      {sub && (
        <Typography sx={{ fontSize: 12, color: 'text.secondary', mt: 0.25 }}>
          {sub}
        </Typography>
      )}
    </Box>
  );

  return (
    <DetailContainer>
      <Dialog fullWidth open={openEditForm} TransitionComponent={Transition} maxWidth="xl">
        <MedicalCertificateForm
          title="EDITAR DOCUMENTO"
          closeDialog={async () => {
            setOpenEditForm(false);
            await loadMedicalCertificate();
          }}
          isOpen={openEditForm}
          medicalCertificateId={`${medicalCertificate?.id}`}
          employeeId={`${medicalCertificate?.employeeId}`}
          handleRequest={listDiseases}
        />
      </Dialog>

      <Box display="flex" alignItems="center" justifyContent="space-between" border="1px solid #1a817a" borderRadius="4px" p={1} mb={1} bgcolor="#1a817a">
        <Tooltip title="Voltar para listagem" placement="left-start">
          <IconButton onClick={() => closeDialog()}>
            <ArrowDropDownIcon />
          </IconButton>
        </Tooltip>
        <Box display="flex" alignItems="center" gap={1}>
          <AppRegistrationIcon sx={{ color: '#FFFFFF' }} />
          <span style={{ color: '#FFFFFF' }}>
            EDITAR ATESTADO
          </span>
        </Box>

        <Box display="flex" alignItems="center" gap={1}>
          <Tooltip title="Anterior" placement="left">
            <IconButton onClick={goToPrev} disabled={!canGoPrev || loadingPage}>
              <ChevronLeft />
            </IconButton>
          </Tooltip>

          <Typography variant="body2">
            {currentIndex + 1} / {totalRows}
          </Typography>

          <Tooltip title="Próximo">
            <IconButton onClick={goToNext} disabled={!canGoNext || loadingPage}>
              <ChevronRight />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <Dialog fullWidth open={openCidForm} TransitionComponent={Transition}>
        <FollowupDiseaseClassificationForm
          closeDialog={() => setOpenCidForm(false)}
          isOpen={openCidForm}
          medicalCertificateId={`${medicalCertificate?.id}`}
          handleRequest={listDiseases}
        />
      </Dialog>
      <Dialog open={isdialogJustifyOpen} fullWidth TransitionComponent={Transition}>
        <FollowupJustification
          handleRequest={eventDescription => updateStatus(dialogStatus, eventDescription)}
          isOpen={isdialogJustifyOpen}
          closeDialog={() => {
            setIsDialogJustifyOpen(false);
          }}
          medicalCertificateId={`${medicalCertificate?.id}`}
          statusMedicalCertificate={dialogStatus}
        />
      </Dialog>
      <Dialog open={openEditDeadline} fullWidth TransitionComponent={Transition}>
        <FollowupEditDeadline
          closeDialog={() => {
            setOpenEditDeadline(false);
          }}
          handleRequest={eventDescription => updateStatus(dialogStatus, eventDescription)}
          isOpen={openEditDeadline}
          medicalCertificate={medicalCertificate}
        />
      </Dialog>

      <Backdrop
        sx={(theme) => ({
          color: '#fff',
          zIndex: theme.zIndex.drawer + 1,
          backgroundColor: 'rgba(0, 0, 0, 0.90)',
        })}
        transitionDuration={{ enter: 100, exit: 700 }}
        open={loading}
      >
        <CircularProgress color="inherit" size={48} />
      </Backdrop>

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', alignContent: 'center', mt: 3 }}>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <h2 style={{
            display: 'flex',
            alignItems: 'center',
            margin: 0,
            letterSpacing: '1px',
          }}>
            <ViewList sx={{ mr: 1 }} />
            Detalhes
          </h2>
          <Card
            sx={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: statusColors[`${medicalCertificate?.status || 'PENDING'}`],
              color: '#fff',
              fontWeight: 500,
              letterSpacing: '1px',
              padding: '4px 12px',
              borderRadius: '16px',
            }}
          >
            {status[`${medicalCertificate?.status || 'PENDING'}`]}
          </Card>
        </Box>

        {hasAccessTo(['atestado-digital-rh'], state.resourcesWithActions) ? (
          <Box>
            <Grid container spacing={1}>
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  disabled={(medicalCertificate ? medicalCertificate.timeQuantity < 24 && !medicalCertificate.alerts?.includes('INSS') : false) || !canView}
                  onClick={() => {
                    setOpenEditDeadline(true);
                  }}
                >
                  Alterar Prazo
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => setOpenEditForm(true)}
                  disabled={
                    medicalCertificate?.status === 'APPROVED' ||
                    medicalCertificate?.status === 'ARCHIVED' ||
                    medicalCertificate?.statusIntegration === 'SUCCESS' ||
                    !canView
                  }
                >
                  Alterar Dados
                </Button>
              </Grid>

              <Grid item>
                <Button
                  variant="contained"
                  color="warning"
                  size="small"
                  onClick={() => {
                    setDialogStatus('ARCHIVED');
                    setIsDialogJustifyOpen(true);
                  }}
                  disabled={
                    medicalCertificate?.status === 'APPROVED' ||
                    medicalCertificate?.status === 'ARCHIVED' ||
                    medicalCertificate?.statusIntegration === 'SUCCESS' ||
                    !canView
                  }
                >
                  Arquivar
                </Button>
              </Grid>

              <Grid item>
                <Button
                  variant="contained"
                  color="error"
                  size="small"
                  onClick={() => {
                    setDialogStatus('DISAPPROVED');
                    setDialogStatus('DISAPPROVED');
                    setIsDialogJustifyOpen(true);
                  }}
                  disabled={
                    medicalCertificate?.status === 'DISAPPROVED' ||
                    medicalCertificate?.status === 'ARCHIVED' ||
                    medicalCertificate?.statusIntegration === 'SUCCESS' ||
                    !canView
                  }
                >
                  Reprovar
                </Button>
              </Grid>

              <Grid item>
                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  onClick={() => {
                    if (company?.allowJustificationWhenApprovingTheDocument) {
                      setDialogStatus('APPROVED');
                      setIsDialogJustifyOpen(true);
                    } else {
                      updateStatus('APPROVED');
                    }
                  }}
                  disabled={
                    medicalCertificate?.status === 'APPROVED' ||
                    medicalCertificate?.status === 'ARCHIVED' ||
                    medicalCertificate?.statusIntegration === 'SUCCESS' ||
                    !canView
                  }
                >
                  Aprovar
                </Button>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <Box>
            <Grid container spacing={1}>
              <Grid item>
                <Button variant="contained" color="primary" size="small" onClick={() => setOpenEditForm(true)} disabled>
                  Alterar Dados
                </Button>
              </Grid>

              <Grid item>
                <Button
                  variant="contained"
                  color="warning"
                  size="small"
                  onClick={() => {
                    setDialogStatus('ARCHIVEDBYMANAGER');
                    setIsDialogJustifyOpen(true);
                  }}
                  disabled={
                    medicalCertificate?.status === 'APPROVED' ||
                    medicalCertificate?.status === 'ARCHIVED' ||
                    medicalCertificate?.status === 'APPROVEDBYMANAGER' ||
                    medicalCertificate?.status === 'ARCHIVEDBYMANAGER' ||
                    medicalCertificate?.statusIntegration === 'SUCCESS' ||
                    !canView
                  }
                >
                  Arquivar
                </Button>
              </Grid>

              <Grid item>
                <Button
                  variant="contained"
                  color="error"
                  size="small"
                  onClick={() => {
                    setDialogStatus('DISAPPROVEDBYMANAGER');
                    setIsDialogJustifyOpen(true);
                  }}
                  disabled={
                    medicalCertificate?.status === 'DISAPPROVED' ||
                    medicalCertificate?.status === 'ARCHIVED' ||
                    medicalCertificate?.status === 'DISAPPROVEDBYMANAGER' ||
                    medicalCertificate?.status === 'ARCHIVEDBYMANAGER' ||
                    medicalCertificate?.statusIntegration === 'SUCCESS' ||
                    !canView
                  }
                >
                  Reprovar
                </Button>
              </Grid>

              <Grid item>
                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  onClick={() => {
                    updateStatus('APPROVEDBYMANAGER');
                  }}
                  disabled={
                    medicalCertificate?.status === 'APPROVED' ||
                    medicalCertificate?.status === 'ARCHIVED' ||
                    medicalCertificate?.status === 'APPROVEDBYMANAGER' ||
                    medicalCertificate?.status === 'ARCHIVEDBYMANAGER' ||
                    medicalCertificate?.statusIntegration === 'SUCCESS' ||
                    !canView
                  }
                >
                  Aprovar
                </Button>
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>

      <Grid container spacing={2} sx={{ marginTop: 2, marginBottom: 6 }}>
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.04),
              borderRadius: 2,
              padding: 2,
              height: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                pb: 2,
                mb: 2,
                borderBottom: (theme) => `0.5px solid ${alpha(theme.palette.text.primary, 0.1)}`,
              }}
            >
              <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontSize: 15, fontWeight: 500 }} noWrap>
                  {medicalCertificate?.employee?.name}
                </Typography>
                <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>
                  Matrícula {medicalCertificate?.employee?.code}
                </Typography>
              </Box>
            </Box>

            <Stack spacing={1.5}>
              <Field label="CPF" value={formatCpf(`${medicalCertificate?.employee?.cpf}`)} mono />
              <Field label="Número do protocolo" value={medicalCertificate?.protocolNumber} mono />
              <Field label="Tipo de documento" value={medicalCertificate?.typeDocument?.description} />
            </Stack>
          </Box>
        </Grid>

        <Grid item xs={12} md={8}>
          <Box
            sx={{
              backgroundColor: (theme) => alpha(theme.palette.info.main, 0.15),
              borderRadius: 2,
              padding: 2,
              mb: 2,
              display: 'flex',
              gap: 2,
              alignItems: 'flex-start',
            }}
          >
            <Box sx={{ flex: '0 0 60%', minWidth: 0 }}>
              <Typography sx={{ fontSize: 11, color: (theme) => theme.palette.info.light }}>
                Período do afastamento
              </Typography>
              <Typography
                sx={{
                  fontSize: 18,
                  fontWeight: 500,
                  color: (theme) => theme.palette.info.light,
                  mt: 0.5,
                }}
              >
                {moment(medicalCertificate?.documentDate).format('DD/MM/yyyy')}
                {medicalCertificate?.typeTime === 'HOUR' && ` ${moment(medicalCertificate?.startTime).format('HH:mm')}h`}
                {' → '}
                {moment(medicalCertificate?.endTime).format('DD/MM/yyyy')}
                {medicalCertificate?.typeTime === 'HOUR' && ` ${moment(medicalCertificate?.endTime).format('HH:mm')}h`}
              </Typography>
              <Typography sx={{ fontSize: 12, color: (theme) => theme.palette.info.light, mt: 0.5 }}>
                por {getTimeQuanitity(medicalCertificate)} ·
                enviado em {moment(medicalCertificate?.createdAt).format('DD/MM/yyyy')} ·
                {medicalCertificate?.statusIntegration === 'SUCCESS' ? ' Integrado' : ' Não integrado'}
              </Typography>
            </Box>

            <Box sx={{ flex: '0 0 40%', minWidth: 0 }}>
              {!!medicalCertificate?.alerts?.length && (
                <Box sx={{display:'flex', flexDirection:'column', alignItems: 'self-end', mr:2}}>
                  <AlertTitle sx={{ fontSize: 14, fontWeight: 600, gap:0.5, display:'flex', alignItems:'center', color: (theme) => theme.palette.error.main }}>
                    <WarningAmberIcon/>  Alerta:
                  </AlertTitle>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.5 }}>
                    {medicalCertificate.alerts.map((alert) => (
                      <Chip key={alert} size="small" color="error" label={alert} sx={{ fontSize: 13 }} />
                    ))}
                  </Box>
                </Box>
              )}
            </Box>
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Field
                label={medicalCertificate?.professionalTypeName || 'Médico'}
                value={medicalCertificate?.professionalName}
                sub={
                  medicalCertificate?.registerNumber
                    ? `${medicalCertificate?.professionalTypeOrganization || 'CRM'} ${medicalCertificate?.professionalState}-${medicalCertificate?.registerNumber}`
                    : undefined
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field label="Local de atendimento" value={medicalCertificate?.clinicName} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field label="Observação" value={medicalCertificate?.notes} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field label="Observação do colaborador" value={medicalCertificate?.comments} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {employee && (
        <Grid sx={{ marginTop: '20px', marginLeft: '-4px' }}>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ marginLeft: '-2px' }}
            >
              <Person sx={{ mr: 1 }} /> Informações do colaborador
            </AccordionSummary>
            <Divider />

            <AccordionDetails>
              <Grid container spacing={2} sx={{ marginTop: 1, marginBottom: 2 }}>
                <Grid item lg={4} md={6} sm={12}>
                  <Field label="Empresa" value={employee?.company?.name} />
                </Grid>
                <Grid item lg={4} md={6} sm={12}>
                  <Field label="Filial" value={employee?.subsidiary?.name} />
                </Grid>
                <Grid item lg={4} md={6} sm={12}>
                  <Field label="Centro de custo" value={employee?.costCenter?.name} />
                </Grid>
                <Grid item lg={4} md={6} sm={12}>
                  <Field label="Local de trabalho" value={employee?.local?.name} />
                </Grid>
                <Grid item lg={4} md={6} sm={12}>
                  <Field label="Cargo" value={medicalCertificate?.employee?.post?.name} />
                </Grid>
                <Grid item lg={4} md={6} sm={12}>
                  <Field label="Posto de trabalho" value={employee?.workstation?.name} />
                </Grid>
                <Grid item lg={4} md={6} sm={12}>
                  <Field label="Escala de trabalho" value={employee?.workShift?.description} />
                </Grid>
              </Grid>
            </AccordionDetails>

          </Accordion>
        </Grid>
      )}
      <Grid container>
        <Grid item md={6} sm={12}>
          <Box sx={{ padding: '10px 10px 10px 0px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <h2>Lista de CIDs</h2>
              {medicalCertificate?.statusIntegration !== 'SUCCESS' ? (
                <Tooltip title="Adicionar CID" placement="left">
                  <IconButton
                    sx={{ width: '50px', height: '50px' }}
                    onClick={() => setOpenCidForm(true)}
                    disabled={medicalCertificate?.statusIntegration === 'SUCCESS' || !canView}
                  >
                    <BiAddToQueue />
                  </IconButton>
                </Tooltip>
              ) : null}
            </Box>
            {loadingRemoveDisease ? <LinearProgress /> : <></>}
            <List dense sx={{ px: 1 }}>
              {diesases.map(({ id, description, code }) => (
                <ListItem
                  key={id}
                  secondaryAction={renderDeleteAction(String(id))}
                  sx={{ mt: 1, p: 1 }}
                >
                  <ListItemAvatar>
                    <Avatar>
                      <MdOutlineBadge color="white" />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={seeCID ? description : '***'}
                    secondary={`CID ${seeCID ? code : '***'}`}
                    sx={{ pr: 4 }}
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        </Grid>
        <Grid item md={6} sm={12}>
          <Box sx={{ padding: '10px 0px 10px 10px' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <h2>Anexos</h2>
            </Box>
            <AnexosGrid attachments={attachments} />
          </Box>
        </Grid>
      </Grid>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'left',
          alignItems: 'center',
          marginBottom: '-10px',
        }}
      >
        <h2>Atestados dos Últimos 60 dias</h2>
      </Box>

      {medicalCertificate && <FollowupLastDocuments employeeId={`${medicalCertificate.employeeId}`} />}
    </DetailContainer>
  );
};

export default FollowupDetail;
